import React, { useEffect, useState } from "react";
import VideoJs from "./VideoJs";
import videojs from "video.js";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import styled from "styled-components";

const Player = ({ link, mute, controls, backButton }) => {
    const [linkPlay, setLinkPlay] = useState({});
    const playerRef = React.useRef(null);

    const videoJsOptions = {
        autoplay: true,
        mute: mute ? mute : true,
        controls: controls ? controls : false,
        responsive: true,
        fluid: true,
    };

    useEffect(() => {
        setLinkPlay({
            src: link,
            type: "application/x-mpegURL",
        });
    }, [link]);

    const handlePlayerReady = (player) => {
        playerRef.current = player;

        // You can handle player events here, for example:
        player.on("waiting", () => {
            videojs.log("player is waiting");
        });

        player.on("dispose", () => {
            videojs.log("player will dispose");
        });
    };

    return (
        <Container>
            {backButton && (
                <div className="back">
                    <KeyboardBackspaceIcon sx={{ color: "white" }} />
                </div>
            )}

            <VideoJs
                options={videoJsOptions}
                source={linkPlay}
                onReady={handlePlayerReady}
            />
        </Container>
    );
};
const Container = styled.div`
    width: 100%;
    height: 100%;
    .back {
        position: absolute;
        padding: 2rem;
        z-index: 1;
        svg {
            font-size: 3rem;
            cursor: pointer;
        }
    }
`;

export default Player;
